export const useRestError = () => {
	// Bad request error
	function newBadRequestError(message: string): RestErr {
		return {
			status: 400,
			message,
			error: 'bad_request_error',
		}
	}

	// Internal server error
	function newInternalServerError(message: string): RestErr {
		return {
			status: 500,
			message,
			error: 'internal_server_error',
		}
	}

	// Not found error
	function newNotFoundError(message: string): RestErr {
		return {
			status: 404,
			message,
			error: 'not_found_error',
		}
	}

	// Unauthorized error
	function newUnauthorizedError(message: string): RestErr {
		return {
			status: 401,
			message,
			error: 'unauthorized_error',
		}
	}

	// Forbidden error
	function newForbiddenError(message: string): RestErr {
		return {
			status: 403,
			message,
			error: 'forbidden_error',
		}
	}

	return {
		newBadRequestError,
		newInternalServerError,
		newNotFoundError,
		newUnauthorizedError,
		newForbiddenError,
	}
}
